"use strict";
/**
 * The four sign-up pages' shared frame and page copy, word for word from Anthony's
 * "How Fomo-Fi Works" (Oct 23, 2026; close_spec doc 3, "Every sign-up page" and
 * "The sign-up pages"). Both apps read these, so the step names and the counts
 * can't drift apart.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.SIGNUP_ANALYSIS_WAIT_COPY = exports.SIGNUP_FINISH_RETRY_COPY = exports.SIGNUP_FINISH_ERROR_COPY = exports.SIGNUP_ANALYSIS_SPENDING_DONE_COPY = exports.SIGNUP_ANALYSIS_SPENDING_WORKING_COPY = exports.SIGNUP_ANALYSIS_BILLS_FOUND_COPY = exports.SIGNUP_ANALYSIS_PAYCHECKS_FOUND_COPY = exports.SIGNUP_ANALYSIS_BUTTON_COPY = exports.SIGNUP_ANALYSIS_IMPORTING_COPY = exports.SIGNUP_ANALYSIS_SUBLINE_COPY = exports.SIGNUP_ANALYSIS_HEADING_COPY = exports.BANK_NOT_FOUND_COPY = exports.SIGNUP_CONNECT_BANK_SMALL_PRINT_COPY = exports.SIGNUP_CONNECT_BANK_BUTTON_COPY = exports.SIGNUP_CONNECT_BANK_SUBLINE_COPY = exports.SIGNUP_CONNECT_BANK_HEADING_COPY = exports.SIGNUP_PASSWORDS_OK_COPY = exports.SIGNUP_CREATE_ACCOUNT_BUTTON_COPY = exports.SIGNUP_CREATE_ACCOUNT_SUBLINE_COPY = exports.SIGNUP_CREATE_ACCOUNT_HEADING_COPY = exports.SIGNUP_STEP_LABELS_COPY = void 0;
exports.signupStepCopy = signupStepCopy;
/** The step bar's four names, in order. */
exports.SIGNUP_STEP_LABELS_COPY = [
    "Account",
    "Payment",
    "Bank",
    "Analysis",
];
/** The header's count, e.g. "Step 2 of 4". */
function signupStepCopy(step) {
    return `Step ${step} of ${exports.SIGNUP_STEP_LABELS_COPY.length}`;
}
/** 1 · Create account. */
exports.SIGNUP_CREATE_ACCOUNT_HEADING_COPY = "Create your account";
exports.SIGNUP_CREATE_ACCOUNT_SUBLINE_COPY = "Know what you can safely spend before payday hits.";
exports.SIGNUP_CREATE_ACCOUNT_BUTTON_COPY = "Create account";
exports.SIGNUP_PASSWORDS_OK_COPY = "Strong password · passwords match";
/** 3 · Connect bank. */
exports.SIGNUP_CONNECT_BANK_HEADING_COPY = "Connect your bank";
exports.SIGNUP_CONNECT_BANK_SUBLINE_COPY = "Pick the checking account your paychecks land in.";
exports.SIGNUP_CONNECT_BANK_BUTTON_COPY = "Connect bank";
exports.SIGNUP_CONNECT_BANK_SMALL_PRINT_COPY = "Connected securely through Plaid. Can't find your bank? You won't be charged if you stop here.";
/** 3 · Connect bank, when a search finds nothing (D23). The amber panel's design is held
 *  (Part 4 #4); the sentence is fixed now so both apps use the same words. */
exports.BANK_NOT_FOUND_COPY = "We couldn't find that bank. Check the spelling or try another bank. If you stop here, your trial ends and you won't be charged.";
/** 4 · Analysis. */
exports.SIGNUP_ANALYSIS_HEADING_COPY = "Reviewing 12 months of your money";
exports.SIGNUP_ANALYSIS_SUBLINE_COPY = "Finding your paychecks, bills and everyday spending.";
exports.SIGNUP_ANALYSIS_IMPORTING_COPY = "Importing transactions";
exports.SIGNUP_ANALYSIS_BUTTON_COPY = "See my results in Plan";
/** The status line under the progress bar, one phrase per stage. */
exports.SIGNUP_ANALYSIS_PAYCHECKS_FOUND_COPY = "Paychecks found";
exports.SIGNUP_ANALYSIS_BILLS_FOUND_COPY = "Repeating bills found";
exports.SIGNUP_ANALYSIS_SPENDING_WORKING_COPY = "Everyday spending, working…";
exports.SIGNUP_ANALYSIS_SPENDING_DONE_COPY = "Everyday spending found";
/** 4 · Analysis, when finishing setup fails, and the way to try again (web's inline
 *  strings, moved here for both apps; rule 17, 2026-10-28). */
exports.SIGNUP_FINISH_ERROR_COPY = "We couldn't finish setting up. Check your connection and try again.";
exports.SIGNUP_FINISH_RETRY_COPY = "Try again";
/** Why "See my results in Plan" is off, for a screen reader (D25; the disabled look isn't
 *  designed, Part 4 #3). */
exports.SIGNUP_ANALYSIS_WAIT_COPY = "Available when the analysis completes.";
//# sourceMappingURL=signupShellCopy.js.map